import {
    BalanceActionTypes,
    GenericActionTypes,
    InWarehouseActionTypes,
    MessagesManagementActionTypes,
    OrderPopupActionTypes,
    ReadyForShipmentActionTypes, StaticDataActionTypes,
    WarehouseManagementActionTypes
} from "./action-types.enum";

export const ActionKeys: {[key: string]: string} = {
    [InWarehouseActionTypes.MARK_AS_READY_FOR_SHIPMENT]: 'mark_as_ready_for_shipment',
    [InWarehouseActionTypes.SELECT_ORDERS_TO_LOCATE]: 'select_orders_to_locate',
    [InWarehouseActionTypes.SELECT_LOCATION_AND_ADD_ORDERS]: 'select_location_and_add_orders',
    [InWarehouseActionTypes.PRE_SELECT_LOCATION_AND_ADD_ORDERS]: 'select_orders_to_locate',
    [InWarehouseActionTypes.EXPORT]: 'export_list',
    [InWarehouseActionTypes.NOT_PREDEFINED]: 'change_statuses',
    [InWarehouseActionTypes.PRINT_BLANK]: 'print_blank_for_warehouse',
    [InWarehouseActionTypes.LOCATE]: 'locate',
    [InWarehouseActionTypes.CHANGE_STATUS]: 'change_status',
    [InWarehouseActionTypes.READY_FOR_PICKUP]: 'mark_as_ready_for_pickup',
    [InWarehouseActionTypes.ANNOUNCE]: 'announce',

    [ReadyForShipmentActionTypes.MARK_AS_SENT]: 'mark_as_sent',
    [ReadyForShipmentActionTypes.SELECT_ORDERS_AND_ADD_TO_GROUP]: 'select_orders_and_add_to_group',
    [ReadyForShipmentActionTypes.SELECT_GROUP_AND_ADD_ORDERS]: 'select_group_and_add_orders',
    [ReadyForShipmentActionTypes.SELECT_GROUPS_OR_ORDERS_TO_LOCATE]: 'select_groups_or_orders_to_locate',
    [ReadyForShipmentActionTypes.SELECT_LOCATION_AND_ADD_GROUPS_OR_ORDERS]: 'select_location_and_add_groups_or_orders',
    [ReadyForShipmentActionTypes.CHANGE_GROUP_OR_ORDER_STATUSES]: 'change_group_or_order_statuses',
    [ReadyForShipmentActionTypes.EXPORT_GROUPS_OR_ORDERS]: 'export_groups_or_orders',
    [ReadyForShipmentActionTypes.REMOVE_ORDERS_FROM_A_GROUP]: 'export_groups_or_orders',
    [ReadyForShipmentActionTypes.ADD_TO_GROUP]: 'add_to_group',
    [ReadyForShipmentActionTypes.CHANGE_STATUS]: 'change_status',
    [ReadyForShipmentActionTypes.PRINT_BLANK]: 'print_blank_for_warehouse',

    [OrderPopupActionTypes.PRINT_BLANK]: 'print_blank',

    [GenericActionTypes.ADD_TO_GROUP]: 'add_orders',
    [GenericActionTypes.SCAN_FOR_SEARCH]: 'scan_for_search',
    [GenericActionTypes.CREATE_GROUP]: 'create_group',
    [GenericActionTypes.SEE_LOCATION_HISTORY]: 'location_history',
    [GenericActionTypes.SEE_STATUS_HISTORY]: 'status_history',
    [GenericActionTypes.SET_DISCOUNT]: 'set_discount',

    [WarehouseManagementActionTypes.NEW_WAREHOUSE]: 'new_warehouse',
    [WarehouseManagementActionTypes.NEW_WAREHOUSE_WORKER]: 'new_warehouse_worker',

    [MessagesManagementActionTypes.NEW_MESSAGE]: 'new_message',

    [StaticDataActionTypes.EDIT]: 'edit_static_data',
    [StaticDataActionTypes.DELETE]: 'delete_static_data',
    [StaticDataActionTypes.NEW]: 'new_static_data',

    [BalanceActionTypes.TOP_UP]: 'top_up',
    [BalanceActionTypes.GRANT_DISCOUNT]: 'grant_discount',
    [BalanceActionTypes.SEE_BALANCE_HISTORY]: 'see_balance_history',
    [BalanceActionTypes.SEE_BONUS_HISTORY]: 'see_bonus_history',
}
